import { ReactNode } from 'react';
import SPKShareHeader from './SPKShareHeader';

const SPKShareLayout = ({ children }: { children: ReactNode }) => {
  return (
    <div className="w-full min-h-screen bg-spk-offWhite ">
      <SPKShareHeader />
      <div className="container mx-auto flex flex-col px-2">{children}</div>
    </div>
  );
};

export default SPKShareLayout;
